import { useLocation } from "react-router-dom";

export default function PaymentResult() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const trnId = query.get("trnId");
  const orderId = query.get("orderId");
  const status = query.get("status");
  const frontend = query.get("frontend");

  return (
    <div>
      <h1>Payment Result</h1>
      <p>Transaction ID: {trnId}</p>
      <p>Order ID: {orderId}</p>
      <p>Status: {status}</p>
      <p>Frontend Redirect: {frontend}</p>
    </div>
  );
}
